const filter = {
    fmtGender:val => ["男","女"][val] || "未知",
    // 格式化日期精确到天
    fmtDate:(date)=>{
        if(!(date instanceof Date)){
            date = new Date(date)
          }
          const year = date.getFullYear()
          const month = date.getMonth() + 1
          const day = date.getDate()
          return `${[year, month, day].map(formatNumber).join('-')}`
    },
    // 格式化日期精确到时分秒
    fmtTime:(date)=>{
        if(!(date instanceof Date)){
            date = new Date(date)
          }
          const year = date.getFullYear()
          const month = date.getMonth() + 1
          const day = date.getDate()
          const hour = date.getHours()
          const minute = date.getMinutes()
          const second = date.getSeconds()
        
          return `${[year, month, day].map(formatNumber).join('-')} ${[hour, minute, second].map(formatNumber).join(':')}`
    }

}

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : `0${n}`
  }


export default  (Vue)=>{
    Object.keys(filter).forEach(key => {
        Vue.filter(key,filter[key])
    });
}